import React from 'react'
import Link from '../helper/link'

export type ContextLinksTypes = 'monitoring' | 'profiling' | 'errors' | 'history'

interface Props {
    links: Array<{
        type: ContextLinksTypes
        route: string
        params: { [key: string]: string | number | undefined }
        tooltip: string
    }>
}

export class ContextLinks extends React.PureComponent<Props> {
    public render() {
        return (
            <div className="contextLinks">
                <span className="contextLinks-go">Go</span>
                {this.props.links.map((link, index) => (
                    <Link
                        key={index}
                        route={link.route}
                        params={link.params}
                        data-tooltip-text={link.tooltip}
                        className="tw-tooltip tw-tooltip-dataText tw-tooltip--bottomLeft contextLinks-link"
                    >
                        {this.icon(link.type)}
                    </Link>
                ))}
            </div>
        )
    }

    private icon(type: ContextLinksTypes): React.ReactNode {
        switch (type) {
            case 'errors':
                return <i className="fa fa-bug" />
            case 'history':
                return <i className="fa fa-history" />
            case 'monitoring':
                return <i className="fa fa-area-chart" />
            case 'profiling':
                return <i className="fa fa-sitemap" />
        }
    }
}
